import YogurtProduct from 'models/YogurtProduct'

export const packagingInitialState = {
  category: YogurtProduct.category,
  subCategory: YogurtProduct.subCategory,
  VitaminD: YogurtProduct.VitaminD,
  VitaminDCertification: YogurtProduct.VitaminDCertification,
  Sugar: YogurtProduct.Sugar,
  SugarCertification: YogurtProduct.SugarCertification,
  SweetenerCertification: YogurtProduct.SweetenerCertification,
  FatLevel: {
    value: YogurtProduct.FatLevel,
    label: 'Fat Level',
  },
  Flavor: {
    value: YogurtProduct.Flavor,
    label: 'Flavor',
  },
  OtherFlavor: YogurtProduct.OtherFlavor,
  Size: YogurtProduct.Size,
  MultiPackageType: YogurtProduct.MultiPackageType,
  MultiPackageCount: YogurtProduct.MultiPackageCount,
}

export const fatLevelOptions = [
  {
    value: '',
    label: 'Fat Level',
    subCategory: '',
    isDisabled: true,
  },
  {
    value: 'Lowfat',
    label: 'Lowfat',
    subCategory: '002',
  },
  {
    value: 'Nonfat',
    label: 'Nonfat',
    subCategory: '002',
  },
  {
    value: 'Whole Fat Milk',
    label: 'Whole Fat Milk',
    subCategory: '001',
  },
]

export const flavorOptions = [
  {
    value: '',
    label: 'Flavor',
    isDisabled: true,
  },
  {
    value: 'Plain',
    label: 'Plain',
  },
  {
    value: 'Vanilla',
    label: 'Vanilla',
  },
  {
    value: 'Blueberry',
    label: 'Blueberry',
  },
  {
    value: 'Mixed Berry',
    label: 'Mixed Berry',
  },
  {
    value: 'Raspberry',
    label: 'Raspberry',
  },
  {
    value: 'Strawberry',
    label: 'Strawberry',
  },
  {
    value: 'Strawberry Banana',
    label: 'Strawberry Banana',
  },
  {
    value: 'Peach',
    label: 'Peach',
  },
  {
    value: 'Other Fruit Flavor',
    label: 'Other Fruit Flavor',
  },
]
